export enum RefreshableItem {
  CHECKING_ACCOUNTS = 'CHECKING_ACCOUNTS',
  CHECKING_TRANSACTIONS = 'CHECKING_TRANSACTIONS',
  CREDITCARD_ACCOUNTS = 'CREDITCARD_ACCOUNTS',
  CREDITCARD_TRANSACTIONS = 'CREDITCARD_TRANSACTIONS',
  EINVOICES = 'EINVOICES',
  IDENTITY_DATA = 'IDENTITY_DATA',
  INVESTMENT_ACCOUNTS = 'INVESTMENT_ACCOUNTS',
  INVESTMENT_TRANSACTIONS = 'INVESTMENT_TRANSACTIONS',
  LIST_BENEFICIARIES = 'LIST_BENEFICIARIES',
  LOAN_ACCOUNTS = 'LOAN_ACCOUNTS',
  LOAN_TRANSACTIONS = 'LOAN_TRANSACTIONS',
  SAVING_ACCOUNTS = 'SAVING_ACCOUNTS',
  SAVING_TRANSACTIONS = 'SAVING_TRANSACTIONS',
  TRANSFER_DESTINATIONS = 'TRANSFER_DESTINATIONS',
}

export const translateRefreshableItemsToScopes = (refreshableItems: RefreshableItem[]) => {
  const refreshableItemsScopeMap = new Map();

  refreshableItemsScopeMap.set(RefreshableItem.CHECKING_ACCOUNTS, [
    'accounts:read',
    'balances:read',
  ]);
  refreshableItemsScopeMap.set(RefreshableItem.CHECKING_TRANSACTIONS, ['transactions:read']);
  refreshableItemsScopeMap.set(RefreshableItem.SAVING_ACCOUNTS, ['accounts:read', 'balances:read']);
  refreshableItemsScopeMap.set(RefreshableItem.SAVING_TRANSACTIONS, ['transactions:read']);

  refreshableItemsScopeMap.set(RefreshableItem.CREDITCARD_ACCOUNTS, [
    'accounts:read',
    'balances:read',
  ]);
  refreshableItemsScopeMap.set(RefreshableItem.CREDITCARD_TRANSACTIONS, ['transactions:read']);
  refreshableItemsScopeMap.set(RefreshableItem.IDENTITY_DATA, ['identity:read']);

  refreshableItemsScopeMap.set(RefreshableItem.INVESTMENT_ACCOUNTS, [
    'accounts:read',
    'investment-accounts:readonly',
  ]);

  refreshableItemsScopeMap.set(RefreshableItem.LOAN_ACCOUNTS, [
    'accounts:read',
    'loan-accounts:readonly',
  ]);

  const uniqueScopes = refreshableItems.reduce((acc, item) => {
    if (refreshableItemsScopeMap.get(item)) {
      refreshableItemsScopeMap.get(item).forEach((scope: string) => {
        acc.add(scope);
      });
    }

    return acc;
  }, new Set<string>());

  return Array.from(uniqueScopes).join(',');
};
